import { Button, DialogActions, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ResponsiveDialog from '../UI/Dialogs/ResponsiveDialog';
import { useCustomStyles } from '../../hooks';

const EditDeleteRecordOrSerieDialog = ({ showDialog, onClose, onConfirm, isDelete, recordName, serieId }) => {
    const { t } = useTranslation();
    const classes = useCustomStyles();
    return (
        <ResponsiveDialog
            open={showDialog}
            onClose={onClose}
            actionButtons={
                <DialogActions sx={{ ...classes.dialogActions, ...classes.marginBottom }}>
                    <Button onClick={onClose} variant="outlined">
                        {t('action.cancel')}
                    </Button>
                    {isDelete ? (
                        serieId ? (
                            <>
                                <Button onClick={() => onConfirm(true)} variant="outlined">
                                    {t('series.deleteSeries')}
                                </Button>
                                <Button onClick={() => onConfirm(false)} variant="outlined">
                                    {t('series.deleteElement')}
                                </Button>
                            </>
                        ) : (
                            <Button onClick={() => onConfirm(false)} variant="outlined">
                                {t('action.confirm')}
                            </Button>
                        )
                    ) : (
                        <>
                            <Button onClick={() => onConfirm(false)} variant="outlined">
                                {t('series.editSeries')}
                            </Button>
                            <Button onClick={() => onConfirm(true)} variant="outlined">
                                {t('series.editElement')}
                            </Button>
                        </>
                    )}
                </DialogActions>
            }
        >
            <Typography variant="body1">
                <span>{isDelete ? t('dialog.deleteConfirm', { recordName }) : t('series.editScopePrompt')}</span>
            </Typography>
        </ResponsiveDialog>
    );
};

export default EditDeleteRecordOrSerieDialog;
